import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

interface Props {
  onClose: () => void;
}

function FullScreenTopBar({ onClose }: Props) {
  const classes = useStyles();

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <Button onClick={onClose}>Close</Button>
      </Toolbar>
    </AppBar>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  appBar: {
    backgroundColor: theme.palette.common.white,
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default FullScreenTopBar;
